import SimplePage from "@/components/layout/SimplePage";

export default function PathToJudaism() {
  return (
    <SimplePage
      title="Converting to Judaism - Becoming Jewish at TIOB"
      eyebrow="A Journey of Discovery"
      subtitle="Thinking about converting to Judaism or becoming Jewish? Rabbi Karen Fanwick's personalized program walks alongside seekers at the Reform synagogue in Brevard County."
      description="Converting to Judaism or becoming Jewish? Rabbi Karen Fanwick's Path to Judaism program at Temple Israel of Brevard is an open, personalized journey for adult seekers in Melbourne, FL and Brevard County."
      path="/education/path-to-judaism"
      ctaLabel="Contact Rabbi Fanwick"
    >
      <p>
        Are you exploring the possibility of becoming Jewish? Have you been
        drawn to Jewish ideas, ritual, community, or family - and want to
        understand more deeply? Rabbi Karen Fanwick's program <em>A Journey of
        Discovery</em> walks alongside seekers as they study, experience, and
        ultimately decide whether to formally convert.
      </p>

      <h2>What to Expect</h2>
      <ul>
        <li>
          <strong>One-on-one mentorship.</strong> Regular meetings with Rabbi
          Fanwick to discuss readings, questions, and your own spiritual path.
        </li>
        <li>
          <strong>A curriculum of Jewish basics.</strong> Beliefs and practices,
          the Jewish year, Shabbat, lifecycle, history, Hebrew, prayer, and
          ethics.
        </li>
        <li>
          <strong>Lived experience.</strong> Shabbat services, holidays,
          community gatherings - because Judaism is something one does as much
          as something one studies.
        </li>
        <li>
          <strong>No pressure.</strong> Many participants choose to convert at
          the end of the program; others choose to remain engaged students and
          friends of the Jewish people. Both paths are honored.
        </li>
      </ul>

      <h2>For Interfaith Couples & Families</h2>
      <p>
        Whether you are the Jewish or non-Jewish partner, you are welcome here.
        Many of our most active members come from interfaith families. Rabbi
        Fanwick is delighted to meet with couples to talk through Jewish home
        practice, raising children, lifecycle events, and conversion if it
        becomes part of your story.
      </p>

      <h2>Get Started</h2>
      <p>
        Every Journey of Discovery begins with a conversation. To set up an
        introductory meeting with Rabbi Fanwick, please email{" "}
        <a href="mailto:rabbikarenfanwick@tiofbrevard.com">
          rabbikarenfanwick@tiofbrevard.com
        </a>{" "}
        or call the office at (321) 631-9494.
      </p>
    </SimplePage>
  );
}
